import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ID } from '@datorama/akita';
import { Observable, Subscription, tap } from 'rxjs';

import { ApplicationService } from '@state/application';
import { environment } from '@env/environment';
import { UserQuery } from '@state/user';

import { Workflow, WorkflowStore } from './workflow.store';

@Injectable({ providedIn: 'root' })
export class WorkflowService {
  constructor(
    private applicationService: ApplicationService,
    private http: HttpClient,
    private userQuery: UserQuery,
    private workflowStore: WorkflowStore
  ) {}

  getWorkflow(id: ID): Subscription {
    return this.http.get<Workflow>(`${environment.apiUrl}/v1/workflow/${id}`).subscribe({
      error: (error) => {
        if (error.status === 404) this.applicationService.setNotFound();
        this.workflowStore.setLoading(false);
      },
      next: (workflow) => {
        this.workflowStore.update({ workflow });
        this.workflowStore.setLoading(false);
      }
    });
  }

  getAndStoreWorkflow$(id: ID): Observable<Workflow> {
    let url = `${environment.apiUrl}/v1/workflow/${id}`;

    return this.http.get<Workflow>(url).pipe(
      tap({
        next: (workflow) => {
          this.workflowStore.update({ workflow });
        }
      })
    );
  }

  toggleMobileAside(mobileAsideVisible: boolean): void {
    this.workflowStore.update({ mobileAsideVisible });
  }
}
